/**
 * DEV-2684 — Kullanıcı İzinleri ekranında hedefe özgü düzenleme kilidinin (sunucu yanıtındaki
 * `duzenlenebilir` / `duzenleme_engeli`) kısa açıklaması. Kural sunucudadır (RolYetkiServisi); burada
 * yalnız neden kodunun metni durur, kilit kararı verilmez.
 */
const METINLER: { [kod: string]: string } = {
    yonetici_rolu: "Sistem Yöneticisi rolü değiştirilemez.",
    kendi_rolu: "Kendi rolünüzü düzenleyemezsiniz.",
    baskin_rol: "Bu rol sizden geniş yetkili; düzenleyemezsiniz.",
    yonetici_hesabi: "Yönetici hesabı üzerinde işlem yapamazsınız.",
    kendisi: "Kendi rolünüzü ve yetkinizi değiştiremezsiniz.",
    baskin_kisi: "Bu kişi sizden geniş yetkili; değiştiremezsiniz.",
};

/** Kayıt sunucuya göre kilitliyse açıklaması, değilse null. Alan hiç yoksa (eski yanıt) kilit yok sayılır. */
export function duzenlemeEngeli(kayit: any): string | null {
    if (!kayit || kayit.duzenlenebilir !== false) {
        return null;
    }
    return METINLER[kayit.duzenleme_engeli] || "Bu işlem için yetkiniz yok.";
}
